<!--
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-21 12:24:47
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\resourceManagement\index.vue
-->
<template>
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-button type="primary" icon="el-icon-upload" size="small">
          上传
        </el-button>
        <el-button
          plain
          icon="el-icon-folder"
          size="small"
          @click="handleAddType"
        >
          新建类型
        </el-button>
      </div>
    </div>
    <el-table
      :data="folderList"
      v-loading="loading"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
      border
    >
      <el-table-column
        label="文件名"
        prop="fileName"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.isSet">
              <el-input
                ref="inputRef"
                v-model="scope.row.fileName"
                size="small"
                style="margin: 0 10px; width: 50%"
              ></el-input>
              <el-button
                size="mini"
                class="el-icon-check"
                style="color: #129800"
                @click.stop="handleCreateType(scope.row)"
              ></el-button>
              <el-button
                size="mini"
                class="el-icon-close"
                style="color: #ee1200"
                @click.stop="handleCancel(scope.row)"
              ></el-button>
            </div>
            <div v-else>
              <el-link
                style="color: #2a6496"
                type="text"
                @click="handleOpenFolder(scope.row)"
                >{{ scope.row.fileName }}</el-link
              >
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="描述"
        prop="desc"
        align="center"
      ></el-table-column>
      <el-table-column
        label="创建日期"
        prop="createTime"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" width="400">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click.stop="handleOpenFolder"
          >下载</el-button>
          <el-button type="danger" size="small">删除</el-button>
          <el-dropdown size="small" style="margin-left: 10px">
            <el-button plain size="small"
              >更多<i class="el-icon-arrow-down el-icon--right"></i
            ></el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleRename(scope.row)"
                >重命名</el-dropdown-item
              >
              <el-dropdown-item>移动到</el-dropdown-item>
              <el-dropdown-item>复制到</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "resourcePreview",

  components: {},

  mixins: [],

  props: {},

  data() {
    return {
      loading: false,
      // 文件夹列表
      folderList: [
        {
          fileName: "SmartControlApp_Vet.apk",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/UploadFiles/InternalFiles/1595585766498_SmartControlApp_Vet.apk",
        },
        {
          fileName: "SmartControlApp_Vet.apk",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/UploadFiles/InternalFiles/1595585766498_SmartControlApp_Vet.apk",
        },
        {
          fileName: "SmartControlApp_Vet.apk",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/UploadFiles/InternalFiles/1595585766498_SmartControlApp_Vet.apk",
        },
        {
          fileName: "SmartControlApp_Vet.apk",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/UploadFiles/InternalFiles/1595585766498_SmartControlApp_Vet.apk",
        },
        {
          fileName: "SmartControlApp_Vet.apk",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/UploadFiles/InternalFiles/1595585766498_SmartControlApp_Vet.apk",
        },
        {
          fileName: "SmartControlApp_Vet.apk",
          desc: "",
          createTime: "2015-12-01 20:00:00",
          url: "https://test.cloud.siui.com/UploadFiles/InternalFiles/1595585766498_SmartControlApp_Vet.apk",
        },
      ],
    };
  },

  provide() {},

  inject: [],

  watch: {},

  computed: {},

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  methods: {
    /**
     * 新增类型
     */
    handleAddType() {
      this.folderList.unshift({
        fileName: "",
        desc: "",
        isSet: true,
      });
    },
    /**
     * 确认新增类型
     */
    handleCreateType(row) {
      if (row.option !== "rename") {
        row.createTime = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
      }
      row.isSet = false;
    },
    /**
     * 取消新增类型
     */
    handleCancel(row) {
      if (row.option !== "rename") {
        row.isSet = false;
        this.folderList.shift();
      } else {
        row.isSet = false;
      }
    },
    /**
     * 重命名
     */
    handleRename(row) {
      this.$set(row, "isSet", true);
      this.$set(row, "option", "rename");
      this.$nextTick(() => {
        this.$refs["inputRef"] && this.$refs["inputRef"].focus();
      });
    },
    /**
     * 打开文件
     */
    handleOpenFolder(row) {
      window.open(
        "https://test.cloud.siui.com/UploadFiles/InternalFiles/1595585766498_SmartControlApp_Vet.apk"
      );
    },
  },
};
</script> 


<style scoped>
</style>
